var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageLoaded)?_c('about-content',{attrs:{"page-data":_vm.pageData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }